import { Injectable } from '@angular/core';
import { StrapiService } from './strapi.service';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataPreloaderService {

  constructor(private strapiService: StrapiService) { }

  // Map of page names to their API calls
  private pageApiMap: Record<string, Observable<any>[]> = {
    home: [
      this.strapiService.getHomePageHeader(),
      this.strapiService.getCommunityHeader(),
      this.strapiService.getReasonsHeader(),
      this.strapiService.getIntroductoryHeader(),
      this.strapiService.getPackagesHeader(),
      this.strapiService.getPartnersHeader(),
      this.strapiService.getPackages(),
      this.strapiService.getHomePageReasons()
    ],
    about: [
      this.strapiService.getAboutUsIntroduction(),
      this.strapiService.getAboutUsExperience(),
      this.strapiService.getAboutUsContactHeader(),
      this.strapiService.getAboutHeader(),
    ],
    packages: [
      this.strapiService.getServicesHeader(),
      this.strapiService.getServiceSolutions()
    ],
    blogs: [
      this.strapiService.getBlogHeader(),
      this.strapiService.getBlogs()
    ],
    contact: [
      this.strapiService.getContactUsHeader()
    ]
  };

  /**
   * Preloads all Strapi data for main pages at application startup
   */
  public preloadAllData(): Observable<any> {
    // Combine all calls from all pages
    const allApiCalls = Object.values(this.pageApiMap).flat();

    return forkJoin(allApiCalls).pipe(
      tap(() => console.log('Data preload completed successfully')),
      catchError((error) => {
        console.error('Error during data preload:', error);
        return of([]);
      })
    );
  }

  /**
   * Preloads data for a specific page
   * @param pageName - The name of the page to preload data for
   */
  public preloadPageData(pageName: keyof typeof this.pageApiMap): Observable<any> {
    const apiCalls = this.pageApiMap[pageName];

    if (!apiCalls) {
      console.warn(`⚠ Unknown page name: ${pageName}`);
      return of(null);
    }

    return forkJoin(apiCalls).pipe(
      tap(() => console.log(`✅ ${pageName} page data preloaded successfully`)),
      catchError((error) => {
        console.error(`❌ Error preloading ${pageName} page data:`, error);
        return of([]);
      })
    );
  }
}
